
import { 
  collection, 
  addDoc, 
  getDocs, 
  deleteDoc, 
  doc, 
  getDoc,
  updateDoc,
  query, 
  orderBy, 
  serverTimestamp
} from 'firebase/firestore';
import { db } from './config';
import { uploadToStorage, googleDriveService } from './googleDrive';


export const newsService = {
  async addNews(newsData, mediaFile = null) {
    try {
      let mediaUrl = null;
      let mediaType = newsData.mediaType || 'image';
      let driveFileId = null;
      let thumbnailUrl = null;

      if (mediaFile) {
        const timestamp = Date.now();
        const fileName = `news_${timestamp}_${mediaFile.name}`;
        
        const uploadResult = await uploadToStorage(mediaFile, fileName);
        
        mediaUrl = uploadResult.publicUrl;
        driveFileId = uploadResult.id;
        thumbnailUrl = uploadResult.thumbnailUrl;
        mediaType = mediaFile.type.startsWith('video/') ? 'video' : 'image';
      }

      const newsToSave = {
        title: newsData.title,
        subtitle: newsData.subtitle,
        fullContent: newsData.fullContent || newsData.subtitle,
        category: newsData.category || 'Geral',
        author: newsData.author || 'Redação Arena Esporte Total',
        isHighlighted: newsData.isHighlighted || false,
        mediaUrl: mediaUrl,
        mediaType: mediaType,
        driveFileId: driveFileId,
        thumbnailUrl: thumbnailUrl,
        storageType: 'google_drive',
        createdAt: serverTimestamp(),
      };
      const docRef = await addDoc(collection(db, 'news'), newsToSave);
      
      return {
        id: docRef.id,
        ...newsToSave,
        createdAt: new Date().toISOString()
      };
    } catch (error) {
      console.error('❌ Erro no newsService.addNews:', error);
      throw new Error('Falha ao adicionar notícia: ' + error.message);
    }
  },

  async getAllNews() {
    try {
      const q = query(
        collection(db, 'news'), 
        orderBy('createdAt', 'desc')
      );
      const querySnapshot = await getDocs(q);
      
      const news = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        news.push({
          id: doc.id,
          ...data,
          createdAt: data.createdAt?.toDate?.()?.toISOString() || data.createdAt
        });
      });
      return news;
    } catch (error) {
      console.error('Erro no newsService.getAllNews:', error);
      throw new Error('Falha ao buscar notícias: ' + error.message);
    }
  },

  async getNewsById(newsId) {
    try {
      console.log('Buscando notícia por ID:', newsId);
      const docRef = doc(db, 'news', newsId);
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
        throw new Error('Notícia não encontrada');
      }

      const data = docSnap.data();
      const foundNews = {
        id: docSnap.id,
        ...data,
        createdAt: data.createdAt?.toDate?.()?.toISOString() || data.createdAt
      };

      console.log('Notícia encontrada:', foundNews);
      return foundNews;
    } catch (error) {
      console.error('Erro no newsService.getNewsById:', error);
      throw new Error('Falha ao buscar notícia: ' + error.message);
    }
  },

  async updateNews(newsId, newsData, mediaFile = null) {
    try {
      console.log('Atualizando notícia:', newsId, newsData);
      
      let mediaUrl = newsData.mediaUrl;
      let mediaType = newsData.mediaType;
      let driveFileId = newsData.driveFileId;
      let thumbnailUrl = newsData.thumbnailUrl;

      if (mediaFile) {
        const timestamp = Date.now();
        const fileName = `news_${timestamp}_${mediaFile.name}`;
        
        console.log('📤 Fazendo upload do novo arquivo:', fileName);
        console.log('🔧 Usando Google Drive para armazenamento');
        
        if (newsData.driveFileId && newsData.storageType === 'google_drive') {
          try {
            await googleDriveService.deleteFile(newsData.driveFileId);
            console.log('🗑️ Arquivo antigo deletado do Google Drive');
          } catch (error) {
            console.warn('⚠️ Não foi possível deletar arquivo antigo:', error.message);
          }
        }
        
        const uploadResult = await uploadToStorage(mediaFile, fileName);
        mediaUrl = uploadResult.publicUrl;
        driveFileId = uploadResult.id;
        thumbnailUrl = uploadResult.thumbnailUrl;
        mediaType = mediaFile.type.startsWith('video/') ? 'video' : 'image';
      }

      const newsToUpdate = {
        title: newsData.title,
        subtitle: newsData.subtitle,
        fullContent: newsData.fullContent || newsData.subtitle,
        category: newsData.category || 'Geral',
        author: newsData.author || 'Redação Arena Esporte Total',
        isHighlighted: newsData.isHighlighted || false,
        mediaUrl: mediaUrl,
        mediaType: mediaType,
        driveFileId: driveFileId,
        storageType: 'google_drive',
        updatedAt: serverTimestamp(),
      };
      if (typeof thumbnailUrl === 'string' && thumbnailUrl.trim() !== '') {
        newsToUpdate.thumbnailUrl = thumbnailUrl;
      }
      console.log('💾 Atualizando notícia no Firestore:', newsToUpdate);
      const docRef = doc(db, 'news', newsId);
      await updateDoc(docRef, newsToUpdate);
      
      return {
        id: newsId,
        ...newsToUpdate,
        updatedAt: new Date().toISOString()
      };
    } catch (error) {
      console.error('❌ Erro no newsService.updateNews:', error);
      throw new Error('Falha ao atualizar notícia: ' + error.message);
    }
  },

  async deleteNews(newsId) {
    try {
      console.log('🗑️ Deletando notícia:', newsId);
      
      const newsDoc = await getDocs(query(collection(db, 'news')));
      let newsToDelete = null;
      
      newsDoc.forEach((doc) => {
        if (doc.id === newsId) {
          newsToDelete = { id: doc.id, ...doc.data() };
        }
      });
      
      if (newsToDelete?.driveFileId && newsToDelete?.storageType === 'google_drive') {
        try {
          await googleDriveService.deleteFile(newsToDelete.driveFileId);
          console.log('Arquivo deletado do Google Drive');
        } catch (error) {
          console.warn('Não foi possível deletar arquivo do Google Drive:', error.message);
        }
      }
      
      await deleteDoc(doc(db, 'news', newsId));
      console.log('Notícia deletada com sucesso');
    } catch (error) {
      console.error('Erro no newsService.deleteNews:', error);
      throw new Error('Falha ao deletar notícia: ' + error.message);
    }
  }
};

// ========== SERVIÇOS DE PATROCINADORES ==========

export const sponsorService = {
  async addSponsor(imageFile) {
    try {
      console.log('Adicionando patrocinador com imagem:', imageFile.name);
      
      let imageUrl = null;
      let driveFileId = null;
      let thumbnailUrl = null;

      if (imageFile) {
        const timestamp = Date.now();
        const fileName = `sponsor_${timestamp}_${imageFile.name}`;
        
        const uploadResult = await uploadToStorage(imageFile, fileName);
        
        imageUrl = uploadResult.publicUrl;
        driveFileId = uploadResult.id;
        thumbnailUrl = uploadResult.thumbnailUrl;
      }

      const sponsorData = {
        imageUrl: imageUrl,
        driveFileId: driveFileId,
        thumbnailUrl: thumbnailUrl,
        storageType: 'google_drive',
        createdAt: serverTimestamp(),
      };

      const docRef = await addDoc(collection(db, 'sponsors'), sponsorData);
      
      return {
        id: docRef.id,
        ...sponsorData,
        createdAt: new Date().toISOString()
      };
    } catch (error) {
      console.error('Erro no sponsorService.addSponsor:', error);
      throw new Error('Falha ao adicionar patrocinador: ' + error.message);
    }
  },

  async getAllSponsors() {
    try {
      const q = query(
        collection(db, 'sponsors'), 
        orderBy('createdAt', 'asc')
      );
      const querySnapshot = await getDocs(q);
      
      const sponsors = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        sponsors.push({
          id: doc.id,
          ...data,
          createdAt: data.createdAt?.toDate?.()?.toISOString() || data.createdAt
        });
      });
      return sponsors;
    } catch (error) {
      console.error('Erro no sponsorService.getAllSponsors:', error);
      throw new Error('Falha ao buscar patrocinadores: ' + error.message);
    }
  },

  async deleteSponsor(sponsorId, driveFileId = null) {
    try {
      // Deletar arquivo do Google Drive se existir
      if (driveFileId && googleDriveService) {
        try {
          await googleDriveService.deleteFile(driveFileId);
          console.log('✅ Arquivo do Google Drive deletado:', driveFileId);
        } catch (driveError) {
          console.warn('⚠️ Não foi possível deletar o arquivo do Google Drive:', driveError.message);
        }
      }
      
      await deleteDoc(doc(db, 'sponsors', sponsorId));
    } catch (error) {
      console.error('Erro no sponsorService.deleteSponsor:', error);
      throw new Error('Falha ao deletar patrocinador: ' + error.message);
    }
  }
};
